export default "__VITE_ASSET__BAFW8V4s__"